import { render, staticRenderFns } from "./hisrotical-settlement-detail-inquiry.vue?vue&type=template&id=078a7c5c&scoped=true&"
import script from "./hisrotical-settlement-detail-inquiry.vue?vue&type=script&lang=js&"
export * from "./hisrotical-settlement-detail-inquiry.vue?vue&type=script&lang=js&"
import style0 from "./hisrotical-settlement-detail-inquiry.vue?vue&type=style&index=0&id=078a7c5c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "078a7c5c",
  null
  
)

export default component.exports